module.exports = __webpack_public_path__ + "static/bannerrevised2-e5a7ba072d10f5d52a0c41261b696859.png";